import { Toaster } from 'sonner';

import { useRegisterShortcut } from '@erp-core/shortcuts';

import { useUIStore } from '@stores/ui-store';

import { ERPLoadingOverlay } from '@shared/components/erp/ERPLoadingOverlay';
import {
  ERPHeader,
  ERPSidebar,
  ERPUtilityPanel,
  ERPWorkspace,
} from '@shared/components/erp/layout';

import styles from './ERPLayout.module.scss';

export function ERPLayout() {
  const sidebarCollapsed = useUIStore((s) => s.sidebarCollapsed);
  const toggleSidebar = useUIStore((s) => s.toggleSidebar);
  const openGlobalSearch = useUIStore((s) => s.openGlobalSearch);
  const toggleUtilityPanel = useUIStore((s) => s.toggleUtilityPanel);

  // ── Global shortcuts ─────────────────────────────────────────────────────

  // Ctrl+B — toggle sidebar
  useRegisterShortcut({
    id: 'layout:toggle-sidebar',
    combo: { key: 'b', modifiers: ['ctrl'] },
    scope: 'global',
    handler: toggleSidebar,
    meta: { label: 'Toggle sidebar', group: 'Layout', visible: true },
  });

  // Ctrl+K — open global search
  useRegisterShortcut({
    id: 'layout:global-search',
    combo: { key: 'k', modifiers: ['ctrl'] },
    scope: 'global',
    handler: openGlobalSearch,
    meta: { label: 'Global search', group: 'Layout', visible: true },
  });

  // Ctrl+Shift+P — toggle utility panel
  useRegisterShortcut({
    id: 'layout:utility-panel',
    combo: { key: 'p', modifiers: ['ctrl', 'shift'] },
    scope: 'global',
    handler: () => toggleUtilityPanel(),
    meta: { label: 'Toggle quick panel', group: 'Layout', visible: true },
  });

  // ── Render ───────────────────────────────────────────────────────────────

  return (
    <div className={styles.shell} data-sidebar-collapsed={sidebarCollapsed ? 'true' : 'false'}>
      {/* ── Sidebar ─────────────────────────────────────────────────────── */}
      <ERPSidebar />

      {/* ── Main panel ──────────────────────────────────────────────────── */}
      <div className={styles.main}>
        <ERPHeader />
        <ERPWorkspace />
      </div>

      {/* ── Utility panel (fixed overlay, right side) ───────────────────── */}
      <ERPUtilityPanel />

      {/* ── Global loading overlay (blocks all interaction) ──────────────── */}
      <ERPLoadingOverlay />

      {/* ── Toast notifications (Sonner) ────────────────────────────────── */}
      <Toaster
        position="bottom-right"
        richColors
        expand={false}
        duration={4000}
        closeButton
        toastOptions={{
          style: {
            fontFamily: 'var(--font-family-base)',
            fontSize: '13px',
            borderRadius: '6px',
          },
        }}
      />
    </div>
  );
}
